import mdcChipSet from './mdc-chip-set.vue'
import mdcChip from './mdc-chip.vue'
export const mdcChipComponents = {
  mdcChip,
  mdcChipSet,
}